import React, { useState } from "react";
import styled from "styled-components";
import { useExport } from "../../../../hooks/useExport";
import { Colors } from "../../../../utils/colors/colors";

type Props = {
  service: string;
  image: string;
  summary: string;
};

const {
  whiteColor,
  secondaryColor,
  primaryColor,
  grayColor
} = Colors();

const SMEsCard = (props: Props) => {
  const { lightArrowIcon } = useExport();
  const [mouseEnter, setMouseEnter] = useState(false);

  return (
    <SMEsCardWrapper
      onMouseEnter={() => setMouseEnter(true)}
      onMouseLeave={() => setMouseEnter(false)}
      onClick={() => setMouseEnter(true)}
      style={{
        backgroundColor: !mouseEnter ? whiteColor : secondaryColor,
      }}
    >
      <ImageFrame
        style={{
          backgroundImage: `url(${props.image})`,
        }}
      />
      <Text
        style={{
          fontWeight: 700,
          fontSize: "20px",
          lineHeight: "140%",
          color: !mouseEnter ? secondaryColor : primaryColor,
        }}
        data-aos="fade-up"
        data-aos-once="true"
      >
        {props.service}
      </Text>
      <Text
        style={{
          minHeight: "105px",
          maxHeight: "105px",
          color: !mouseEnter ? grayColor : whiteColor,
        }}
        data-aos="fade-up"
        data-aos-once="true"
      >
        {props.summary}
      </Text>

      {mouseEnter && (
        <a
          href="https://era-tek.io/"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "flex",
            gap: "4px",
          }}
          data-aos="fade-up"
          data-aos-once="true"
        >
          <Text
            style={{
              color: whiteColor,
              cursor: "pointer",
            }}
          >
            Visit Our Website
          </Text>
          <img
            src={lightArrowIcon}
            alt="Arrow up icon"
          />
        </a>
      )}
    </SMEsCardWrapper>
  );
};

export default SMEsCard;

const SMEsCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
  gap: 20px;
  width: 100%;
  height: 380px;
  border-radius: 30px;
  margin: 1rem 0;
  transition: ease background-color 0.6s;
  cursor: pointer;
  background-color: ${whiteColor};

  &:hover {
    background-color: ${secondaryColor};
  }
`;

const Text = styled.div`
  font-family: "Nunito";
  font-style: normal;
  color: #4f4f4f;
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
`;

const ImageFrame = styled.div`
  width: 100%;
  height: 180px;
  padding: 0;
  border-radius: 20px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;
  background-color: var(--white-color);
`;
